import DayShedule from './DayShedule';

export default DayShedule;
